import { useState } from 'react';
import { useSnackbar } from 'notistack';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { Box, Button, CircularProgress, IconButton, ImageListItemBar, TextField, Tooltip, Typography } from '@mui/material';
import { DeleteOutline,  UploadFile, Link, CloudUpload, CloudDone } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { objectToFormData } from '../../utils/objectToFormData';
import axios from '../../utils/axios';

PictureUploader.propTypes = {
  pictures: PropTypes.array,
  addPicture: PropTypes.func,
  removePicture: PropTypes.func,
  baseUrl: PropTypes.string
}
export default function PictureUploader({ pictures, addPicture, removePicture, baseUrl = "/product/uploadPicture" }) {

  const { enqueueSnackbar } = useSnackbar();

  const [uploadUrl, setUploadUrl] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [showUploadFile, setShowUploadFile] = useState(false);
  const [uploadingPicture, setUploadingPicture] = useState(false);

  const readyToUpload = showUploadFile && uploadFile || !showUploadFile && uploadUrl && uploadUrl.includes("http");

  const uploadPicture = () => {
    setUploadingPicture(true);
    axios.post(baseUrl, objectToFormData({ file: showUploadFile ? uploadFile : null, pictureUrl: !showUploadFile ? uploadUrl : null }))
      .then((res) => {
        if (res.data) addPicture(res.data);
        else enqueueSnackbar('Create picture failed', { variant: 'error' })
      })
      .catch(() => enqueueSnackbar('Create picture failed', { variant: 'error' }))
      .finally(() => {
        setUploadUrl("");
        setUploadFile(null);
        setUploadingPicture(false);
      });
  }

  return <>
    <ImageList cols={3} rowHeight={200}>
      {pictures.filter(pic => pic).map((picture) => (
        <ImageListItem key={picture}>
          <img
            src={(picture.includes("res.cloudinary.com/") && picture.includes("upload/") && picture.includes("/Product")) ?
              picture.replace(picture.split("upload/")[1].split("/Product")[0], "c_fit,w_200,h_200,q_auto,f_auto,fl_progressive,e_bgremoval") : picture}
            alt={"Product Pic"}
            loading="lazy"
          />
          <ImageListItemBar
            sx={{
              background:
                'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
            }}
            position="top"
            actionIcon={<IconButton onClick={() => removePicture(picture)} color="error">
                <DeleteOutline />
              </IconButton>}
            actionPosition="right"
          />
        </ImageListItem>
      ))}
    </ImageList>
    <Box sx={pictures.length ? { mt: 2 } : {}}>
      <Typography variant="subtitle1">Upload Picture {showUploadFile ? "File" : "URL"}</Typography>
      {!showUploadFile && <TextField
        name="uploadUrl"
        value={uploadUrl}
        sx={{ width: `calc(100% - ${readyToUpload ? "80px" : "40px"})` }}
        onChange={(e) => setUploadUrl(e.target.value)}
        size="small"
      />}
      {showUploadFile && <Button component="label" variant="contained" sx={{ width: `calc(100% - ${readyToUpload ? "80px" : "40px"})` }} startIcon={<CloudUpload />}>
        Upload file{uploadFile ? <Box sx={{ textTransform: "none" }}>: {uploadFile.name}</Box> : ""}
        <input type="file" hidden onChange={(event) => setUploadFile(event.target.files?.length ? event.target.files[0] : null)} />
      </Button>}
      {readyToUpload && <Tooltip title={`Add picture`}>
        <IconButton disableRipple onClick={uploadPicture}>
          {uploadingPicture ? <CircularProgress size={24} /> : <CloudDone />}
        </IconButton>
      </Tooltip>}
      <Tooltip title={`Upload picture as ${showUploadFile ? "link" : "file"}`}>
        <IconButton disableRipple onClick={() => setShowUploadFile(!showUploadFile)}>
          {!showUploadFile ? <UploadFile /> : <Link />}
        </IconButton>
      </Tooltip>
    </Box>
  </>;
}